
const Skills = () => {

    return (
        <div className="flex justify-center">
            <div className="w-full max-w-[1280px] py-20 flex flex-col lg:flex-row justify-center items-center mb-0 lg:mb-12 text-animate">
                    <div className="w-80 border-r-0 lg:border-r border-gray-700 flex flex-col items-center mb-16 lg:mb-0">
                        <div className="flex flex-col items-center h-32">
                            <img
                                className="w-9 mb-8"
                                src="icons/pens.svg"
                                alt=""
                            />
                            <div className="text-10">Designer</div>
                        </div>
                        <div className="flex flex-col items-center h-24 text-sm text-gray-400 text-center">
                            Eye to detail, value clean design patterns,
                            <br />
                            and thoughtful interactions.
                        </div>
                        <div className="flex flex-col items-center h-24 text-sm text-center">
                            <div className="text-center mb-5">
                                Things I enjoy designing:
                            </div>
                            <div className="text-gray-400">
                                UX, UI, Web, Mobile, Apps, Logos
                            </div>
                        </div>
                        <div className="flex flex-col items-center h-36 text-sm text-center">
                            <div className="text-center mb-5">
                                Design tools:
                            </div>
                            <div className="text-gray-400">
                                Figma
                                <br />
                                Photoshop
                                <br />
                                Illustrator
                                <br />
                                After effects
                            </div>
                        </div>
                    </div>
                    <div className="w-80 border-r-0 lg:border-r border-gray-700 flex flex-col items-center mb-16 lg:mb-0">
                        <div className="flex flex-col items-center h-32">
                            <img
                                className="w-9 mb-8"
                                src="icons/frontend.svg"
                                alt=""
                            />
                            <div className="text-10">
                                Front-end Developer
                            </div>
                        </div>
                        <div className="flex flex-col items-center h-24 text-sm text-gray-400 text-center">
                            I like to code from scratch, and
                            <br />
                            enjoy bringing ideas to life.
                        </div>
                        <div className="flex flex-col items-center h-24 text-sm text-center">
                            <div className="text-center mb-5">
                                Languages:
                            </div>
                            <div className="text-gray-400">
                                HTML, CSS, SASS, PHP, Javascript,
                                <br />
                                liquid, React, Typescript, git
                            </div>
                        </div>
                        <div className="flex flex-col items-center h-36 text-sm text-center">
                            <div className="text-center mb-5">
                                Dev Tools:
                            </div>
                            <div className="text-gray-400">
                                VS studio code
                                <br />
                                Linux
                                <br />
                                autohotkey
                                <br />
                                Github
                                <br />
                                Terminal
                                <br />
                                CodePen
                            </div>
                        </div>
                    </div>
                    <div className="w-80 flex flex-col items-center">
                        <div className="flex flex-col items-center h-32">
                            <img
                                className="w-9 mb-8"
                                src="icons/backend.svg"
                                alt=""
                            />
                            <div className="text-10">
                                Backend developer
                            </div>
                        </div>
                        <div className="flex flex-col items-center h-24 text-sm text-gray-400 text-center lg:w-56">
                            Handling a server with the latest security
                            practices allows me to completely create
                            applications with full functionality
                        </div>
                        <div className="flex flex-col items-center h-24 text-sm text-center">
                            <div className="text-center mb-5">
                                Languages:
                            </div>
                            <div className="text-gray-400">
                                NodeJS, Express, MongoDB, Linux, git,
                                Nginx
                            </div>
                        </div>
                        <div className="flex flex-col items-center h-36 text-sm text-center">
                            <div className="text-center mb-5">
                                Dev Tools:
                            </div>
                            <div className="text-gray-400">
                                VS studio code
                                <br />
                                Github
                                <br />
                                Terminal
                            </div>
                        </div>
                    </div>
                </div>
        </div>
    );
};

export default Skills;